export default __webpack_public_path__ + "static/media/phone-call-icon.761a6c8f.svg";